import { render } from "./LabelContentListWidget.vue?vue&type=template&id=ac85b08c&ts=true"
import script from "./LabelContentListWidget.ts?vue&type=script&lang=ts&external"
export * from "./LabelContentListWidget.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__